import styled from 'styled-components';

const BlackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  background-color: ${({ theme }) => theme.COLOR_BLACK};
  width: 100%;
  height: 64px;
  z-index: 10;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
`;

const Bumper = styled.div`
  height: 64px;
`;

const StyledBlackBottomBar = {
  BlackContainer,
  Bumper,
};

export default StyledBlackBottomBar;
